<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
    import style from './style.css'
    export default {
        data () {
            return {}
        }
    }
</script>


// WEBPACK FOOTER //
// App.vue?7cb61684